export const isActiveReduxLogger = false;
export const isActiveReduxDebugger =
  process.env.REACT_APP_IS_ACTIVE_REDUX_DEBUGGER;
